import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AcontoClientView } from '../models';

@Component({
    selector: 'app-interim-invoicing-options',
    templateUrl: './interim-invoicing-options.component.html',
    styleUrls: ['./interim-invoicing-options.component.scss'],
    standalone: false
})
export class InterimInvoicingOptionsComponent {
    @Output() acontoBulk = new EventEmitter<number>();
    @Output() acontoDate = new EventEmitter<string>();
    @Output() acontoType = new EventEmitter<number>();
    @Input() acontoClients: AcontoClientView[];

    onAcontoDate(acontoDate: string) {
        this.acontoDate.emit(acontoDate);
    }

    onAcontoType(acontoType: number) {
        this.acontoType.emit(acontoType);
    }

    onAcontoBulk() {
        const bulkCount = this.acontoClients.filter(ac => ac.accfaktureret < ac.accbelob).length || 0;
        this.acontoBulk.emit(bulkCount);
    }
}
